/**
 * Where the web sends people to get the apps.
 *
 * `WEB_BOOKING_ENABLED` now defaults on, so these are the secondary path: the
 * estimate widget books on the web, and the store links carry what the web
 * cannot do — scheduling ahead, messaging, cancelling, and approving a
 * driver-proposed fare. With the flag off they go back to being the only path,
 * and stay correct either way.
 *
 * The user app is live on Google Play. The driver app is still distributed as
 * an Android APK through Expo, and there is no iOS listing yet.
 */

export const USER_APP_URL =
  'https://play.google.com/store/apps/details?id=co.za.shiftwagon&pcampaignid=web_share';

/* Note the project differs from the user app: the driver build lives under
   `shift-wagon`, not `shift-wagon-user`. Getting this wrong hands drivers the
   customer app, so keep it in step with DriverProfileSetupPage. */
export const DRIVER_APP_URL =
  'https://expo.dev/accounts/shiftwagon7/projects/shift-wagon/builds/2dbc3acf-d4c5-45d7-b725-c166cb74d0c3';

/** Driver and fleet onboarding is contact-led, not self-serve. */
export const PARTNER_CONTACT_PATH = '/about#contact';
